import { render, staticRenderFns } from "./RecipeIngredient.vue?vue&type=template&id=3d797aaf&scoped=true&"
import script from "./RecipeIngredient.vue?vue&type=script&lang=js&"
export * from "./RecipeIngredient.vue?vue&type=script&lang=js&"
import style0 from "./RecipeIngredient.vue?vue&type=style&index=0&id=3d797aaf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d797aaf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cookbook/cookbook/cookbook/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d797aaf')) {
      api.createRecord('3d797aaf', component.options)
    } else {
      api.reload('3d797aaf', component.options)
    }
    module.hot.accept("./RecipeIngredient.vue?vue&type=template&id=3d797aaf&scoped=true&", function () {
      api.rerender('3d797aaf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RecipeIngredient.vue"
export default component.exports